import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { ImageFromFile } from '../../components';

import css from './UserFieldImage.module.css';

const ACCEPT_IMAGES = 'image/*';

const UserFieldImage = props => {
  const { rootClassName, className, formId, fieldConfig, intl } = props;
  if (!fieldConfig) {
    return null;
  }
  const { key, saveConfig } = fieldConfig;
  const { label: labelText } = saveConfig;

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      <label className={css.label}>
        <FormattedMessage id={labelText} />
      </label>
      <Field
        id={formId ? `${formId}.${key}` : key}
        name={key}
        accept={ACCEPT_IMAGES}
      >
        {fieldProps => {
          const { input, accept, id } = fieldProps;
          const { name, onChange, value } = input;
          const file = value;

          const handleFileChange = e => {
            const selectedFile = e.target.files[0];
            onChange(selectedFile);
          };

          return (
            <div className={css.fieldWrapper}>
              <div className={css.imageWrapper}>
                {file ? (
                  <ImageFromFile
                    id={id}
                    file={file}
                    className={css.imagePreview}
                    aspectWidth={1}
                    aspectHeight={1}
                  />
                ) : (
                  <div className={css.imagePlaceholder}>
                    <FormattedMessage id="SignupForm.addLogoPlaceholder" />
                  </div>
                )}
              </div>
              <label className={css.uploadButton} htmlFor={id}>
                <FormattedMessage id="SignupForm.chooseLogo" />
              </label>
              <input
                id={id}
                name={name}
                type="file"
                accept={accept}
                onChange={handleFileChange}
                className={css.hiddenInput}
              />
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default UserFieldImage;
